





















import { Component, Vue } from 'vue-property-decorator';
import { State } from 'vuex-class';
import openbitlab from '@/types.d';
import { filter, values } from 'lodash';

@Component({
  components: {
  },
})
export default class MainHeader extends Vue {
  @State('projects') projects!: openbitlab.RootState['projects']

  private headerTexts: Array<string> = [
    'Automatic Payouts',
    'Ledger Friendly',
  ]

  getProjectNumber(): number {
    return filter(values(this.projects), (p) => p.status !== 'past').length;
  }
}
